export const CHALLENGE_FACTORY_ABI = [
  {
    type: 'event',
    name: 'ChallengeCreated',
    inputs: [
      { indexed: true, name: 'clone', type: 'address' },
      { indexed: true, name: 'creator', type: 'address' },
      { indexed: false, name: 'challengeType', type: 'uint8' },
      { indexed: false, name: 'name', type: 'string' },
    ],
  },
  {
    type: 'function',
    name: 'getChallenges',
    inputs: [],
    outputs: [{ type: 'address[]' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'isVerifiedCreator',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [{ type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'revokeCreator',
    inputs: [{ name: 'creator', type: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'grantVerifiedCreator',
    inputs: [{ name: 'creator', type: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'revokedCreators',
    inputs: [{ name: '', type: 'address' }],
    outputs: [{ type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'createChallenge',
    inputs: [
      {
        name: 'params',
        type: 'tuple',
        components: [
          { name: 'challengeType', type: 'uint8' },
          { name: 'name', type: 'string' },
          { name: 'startTime', type: 'uint256' },
          { name: 'endTime', type: 'uint256' },
          { name: 'roundDeadlines', type: 'uint256[]' },
          { name: 'minParticipants', type: 'uint256' },
          { name: 'maxParticipants', type: 'uint256' },
          { name: 'entryFee', type: 'uint256' },
          { name: 'winnerCount', type: 'uint256' },
        ],
      },
    ],
    outputs: [{ name: 'clone', type: 'address' }],
    stateMutability: 'payable',
  },
] as const
